import loadable from '@app/ui/components/LazyLoad';

const MessageListModalContent: $TSFixMe = loadable(
  () =>
    import(
      /* webpackChunkName: "lazy.messageListModal" */ './MessageListModal'
    ),
);

export default MessageListModalContent;
